/**
 * Format Ask params for `trackEvent` (Zappalytics events)
 *
 * @param productId  optional string  the ID of the product
 *
 * @param [itemId]     optional string  the ID of the ask item
 *
 * @param [isAnswer]   optional string  true if the given item is an answer (and
 *                                    not a question)
 *
 * @returns          string           the second argument to `trackEvent`
 */
export const formatAskTrackEventParams = (productId?: string, itemId?: string, isAnswer?: boolean): string => {
  let parts: string[] = [];
  if (productId) {
    parts = parts.concat(['ProductID', productId]);
  }
  if (itemId) {
    parts = parts.concat([isAnswer ? 'AnswerID' : 'QuestionID', itemId]);
  }
  return parts.join(':');
};

/** Shorthand for formatAskTrackEventParams(productId, itemId, false) */
export const formatAskQuestionTrackEventParams = (productId: string, questionId: string): string =>
  formatAskTrackEventParams(productId, questionId, false);

/** Shorthand for formatAskTrackEventParams(productId, itemId, true) */
export const formatAskAnswerTrackEventParams = (productId: string, answerId: string): string => formatAskTrackEventParams(productId, answerId, true);
